import type { AuditLogEntry } from "@/lib/manufacturing/types";
import type { TimelineEntry } from "@/lib/activityTimeline/types";

/** Map mfg `audit_log` rows into federated `TimelineEntry` for shared list UI. */
export function auditLogEntryToTimelineEntry(entry: AuditLogEntry): TimelineEntry {
  const entityType = entry.entity_type;
  return {
    id: `audit_log:${entry.id}`,
    source: "audit_log",
    organization_id: entry.organization_id,
    occurred_at: entry.created_at,
    actor_user_id: entry.actor_user_id,
    actor_label: entry.actor_label,
    domain: entityType.startsWith("mfg_") ? "mfg" : "ops",
    entity_type: entityType,
    entity_id: entry.entity_id,
    action: entry.action,
    summary: entry.summary,
    metadata: entry.metadata ?? {},
    before: entry.before,
    after: entry.after,
    deep_link: entityType.startsWith("mfg_") ? "/manufacturing" : null,
  };
}
